module.exports = __webpack_public_path__ + "static/media/country_sg.47313263.webp";